/**
 * @owner @Appboy/messaging-experience
 */
import { customAttributeRemoteLookupValidators } from "../.generated/customAttributeRemoteLookup";
import type { CustomAttributeRemoteLookupProvider } from "../.generated/customAttributeRemoteLookup";

export const customAttributeProvider: CustomAttributeRemoteLookupProvider = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: customAttributeRemoteLookupValidators,
};
